import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export const useSite = () => useContext(SiteContext);

const DEFAULT_CONFIG = {
  phone: "",
  whatsapp_number: "",
  email: "",
  address: "",
  working_hours: "",
  seo_title: "BROX CONSTRUCT — Un singur contact. Tot proiectul.",
  seo_description:
    "Brox Construct este punctul unic de contact pentru construcții, renovări, instalații și lucrări exterioare. Te contactăm în maximum 24 de ore.",
};

export function SiteProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quotePreset, setQuotePreset] = useState({});

  useEffect(() => {
    let active = true;
    api
      .get("/config")
      .then(({ data }) => {
        if (active) setConfig({ ...DEFAULT_CONFIG, ...data });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const openQuote = useCallback((preset = {}) => {
    setQuotePreset(preset);
    setQuoteOpen(true);
    document.body.style.overflow = "hidden";
  }, []);

  const closeQuote = useCallback(() => {
    setQuoteOpen(false);
    document.body.style.overflow = "";
  }, []);

  const whatsappHref = useMemo(() => {
    const number = (config.whatsapp_number || "").replace(/[^0-9]/g, "");
    return (message) => {
      if (!number) return null;
      const text = message || "Bună ziua! Doresc o ofertă BROX CONSTRUCT pentru o lucrare.";
      return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
    };
  }, [config.whatsapp_number]);

  const value = useMemo(
    () => ({ config, openQuote, closeQuote, whatsappHref, quoteOpen, quotePreset }),
    [config, openQuote, closeQuote, whatsappHref, quoteOpen, quotePreset]
  );

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}
